/**
 * taskScheduler 模块接口列表
 * 任务调度中心 - 对接后端文档：AI数字运维工程师 - 前端对接文档
 * 后端基础路径：/sme/agentverse/task
 */
import $http from '../utils/http';

const taskScheduler = {
  // 任务统计：全部 / 待执行 / 执行中 / 已完成
  // GET /sme/agentverse/task/statistics
  getTaskStatistics() {
    return $http.get(`${global.API_URL}/sme/agentverse/task/statistics`);
  },
  // 任务分页列表
  // POST /sme/agentverse/task/page
  pageTaskList(params) {
    return $http.post(`${global.API_URL}/sme/agentverse/task/page`, params || {});
  },
  // 任务详情
  // GET /sme/agentverse/task/detail/{taskNumber}
  getTaskDetail(taskNumber) {
    return $http.get(`${global.API_URL}/sme/agentverse/task/detail/${taskNumber}`);
  },
  // 取消任务
  // PUT /sme/agentverse/task/cancel/{taskNumber}
  cancelTask(taskNumber) {
    return $http.put(`${global.API_URL}/sme/agentverse/task/cancel/${taskNumber}`);
  }
};

export default taskScheduler;



// WEBPACK FOOTER //
// ./src/api/taskScheduler.js